var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgTableChart = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 455 455",
    style: {
      enableBackground: "new 0 0 455 455"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 317.595,
    style: {
      fill: "#9BFBFF"
    },
    width: 98.333,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.333,
    y: 117.215,
    style: {
      fill: "#9BFBFF"
    },
    width: 49.167,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.333,
    y: 317.595,
    style: {
      fill: "#9BFBFF"
    },
    width: 49.167,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 117.215,
    style: {
      fill: "#9BFBFF"
    },
    width: 98.333,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 217.405,
    style: {
      fill: "#9BFBFF"
    },
    width: 98.333,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.333,
    y: 217.405,
    style: {
      fill: "#9BFBFF"
    },
    width: 49.167,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.667,
    y: 217.405,
    style: {
      fill: "#46F8FF"
    },
    width: 98.333,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.5,
    y: 117.215,
    style: {
      fill: "#46F8FF"
    },
    width: 49.167,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.667,
    y: 117.215,
    style: {
      fill: "#46F8FF"
    },
    width: 98.333,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.667,
    y: 317.595,
    style: {
      fill: "#46F8FF"
    },
    width: 98.333,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.5,
    y: 217.405,
    style: {
      fill: "#46F8FF"
    },
    width: 49.167,
    height: 60.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.5,
    y: 317.595,
    style: {
      fill: "#46F8FF"
    },
    width: 49.167,
    height: 60.19
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2488FF"
    },
    d: "M415,117.215v60.19h-98.333v-60.19h-40v60.19h-98.334v-60.19h-40v60.19H40v-60.19H0v300.57h455 v-300.57H415z M40,317.595h98.333v60.19H40V317.595z M178.333,317.595h98.334v60.19h-98.334V317.595z M316.667,317.595H415v60.19 h-98.333V317.595z M415,217.405v60.19h-98.333v-60.19H415z M276.667,217.405v60.19h-98.334v-60.19H276.667z M138.333,217.405v60.19 H40v-60.19H138.333z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 37.215,
    style: {
      fill: "#005ECE"
    },
    width: 227.5,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.5,
    y: 37.215,
    style: {
      fill: "#003F8A"
    },
    width: 227.5,
    height: 80
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTableChart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/table-chart.67f40f2a.svg";
export { ForwardRef as ReactComponent };